const SHARE_REGISTER_DOCUMENT_TYPES = {
  SHARE_REGISTER: {
    value: "share_register",
    readableName: "Share Register",
  },
  STOCK_LEDGER: {
    value: "stock_ledger",
    readableName: "Stock Ledger",
  },
  SHARE_ISSUANCE_REPORT: {
    value: "share_issuance_report",
    readableName: "Share Issuance Report",
  },
  OTHER: {
    value: "other",
    readableName: "Other",
  },
};

export const shareRegisterDocumentTypesArray = Object.values(SHARE_REGISTER_DOCUMENT_TYPES);
